module.exports = __webpack_public_path__ + "media/images/city/077-brandenburg-gate-90f57852f61f339f21a8cb1907af1aa3.svg";